// generated by the plop

import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { AccessState, AccessStateModel, ProfileState, ProfileStateModel, UserModel } from 'shared';
import { PermissionEnum } from 'symbols';
import { DEBTS_ACCESS_DEFAULT, DebtsAccessModel } from './debts-access.model';

@State({ name: 'DebtsAccess' })
@Injectable()
export class DebtsAccessState {

  /**
   * Generate configs for classroom module depends on a provided user role.
   */
  static generateDebtsAccess(roles: PermissionEnum[], user: UserModel): DebtsAccessModel {
    // Return permissions as for an unknown role if user not verified or not authenticated.
    if (!user) {
      return this.generateRoleConfig(PermissionEnum.UNKNOWN);
    }

    // Apply permissions of each provided role.
    const rolesConfig: DebtsAccessModel[] = roles.map(role => this.generateRoleConfig(role));

    // Return defined config.
    return this.mergeConfig(rolesConfig);
  }

  /**
   * Define and create config using provided config data.
   */
  static generateRoleConfig(role: PermissionEnum): DebtsAccessModel {
    switch (role) {
      case PermissionEnum.CAN_READ_DEBTS:
        return {
          ...DEBTS_ACCESS_DEFAULT,
          canReadDebts: true
        };
      case PermissionEnum.CAN_READ_DEBT_BY_ID:
        return {
          ...DEBTS_ACCESS_DEFAULT,
          canReadDebtsById: true
        };
      case PermissionEnum.CAN_WRITE_DEBTS:
        return {
          ...DEBTS_ACCESS_DEFAULT,
          canWriteDebts: true
        };
      case PermissionEnum.SUPER_USER:
        return {
          canReadDebtsById: true,
          canReadDebts: true,
          canWriteDebts: true
        };
      default: {
        return {
          ...DEBTS_ACCESS_DEFAULT
        };
      }
    }
  }

  /**
   * Merge provided roles configs (by union rule).
   */
  static mergeConfig(rolesConfig: DebtsAccessModel[]): DebtsAccessModel {
    const moduleConfig: DebtsAccessModel = DEBTS_ACCESS_DEFAULT;

    for (const config of rolesConfig) {
      moduleConfig.canReadDebtsById = moduleConfig.canReadDebtsById ? true : config.canReadDebtsById;
      moduleConfig.canReadDebts = moduleConfig.canReadDebts ? true : config.canReadDebts;
      moduleConfig.canWriteDebts = moduleConfig.canWriteDebts ? true : config.canWriteDebts;
    }
    return moduleConfig;
  }

  /**
   * Define and create module access rules using provided portal data.
   */
  @Selector([ProfileState, AccessState])
  static accessToDebts(profileState: ProfileStateModel, accessState: AccessStateModel): DebtsAccessModel {
    const userData = profileState.currentUser;
    const roleList = accessState.roles;

    return DebtsAccessState.generateDebtsAccess(roleList, userData);
  }

}


